<!--  -->
<template>
  <!-- 完成注册 -->
  <div class="regist-success-view">
    <img src="~@/assets/login/registSuccess.png" />
    <p>注册成功，欢迎加入LIGHT云</p>
    <div class="butt-cont">
      <h-button type="primary" @click="toUrl('/')" class="gray-butt"
        >返回首页</h-button
      >
      <h-button
        type="primary"
        @click="toUrl('/cloud/open/user/personalCertificaton.html')"
        class="right-butt"
        style="width: 90px; margin-right: 10px"
        >实名认证</h-button
      >
      <h-button
        type="primary"
        @click="toUrl('/cloud/open/user/companyCertificaton.html')"
        class="right-butt"
        style="width: 90px"
        >企业认证</h-button
      >
    </div>
    <PhotonTip v-show="isPhoton"></PhotonTip>
  </div>
</template>

<script>
import PhotonTip from "@/components/photonTip";
export default {
  data() {
    return {};
  },
  components: {
    PhotonTip
  },
  computed: {
    isPhoton() {
      let p = localStorage.getItem("isPhoton");
      return p == "1" ? true : false;
    }
  },
  methods: {
    toUrl(url) {
      window.location.href = url;
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {}
};
</script>
<style lang="scss" scoped>
.regist-success-view {
  width: 840px;
  height: 470px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 5;
  img {
    width: 81px;
    height: 90px;
    margin: 99px 0 20px 0;
    display: inline-block;
  }
  p {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #303133;
    margin: 20px 0 166px 0;
    display: inline-block;
    position: inherit;
  }
  .butt-cont {
    position: absolute;
    bottom: 152px;
    z-index: 101;
    .gray-butt {
      background: transparent;
      border-radius: 2px;
      height: 32px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      border: none;
      margin-right: 10px;
      width: 90px;
      padding: 0px 8px;
      border: 1px solid #bfc4cd;
      color: #666666;
    }
  }
}
/* @import url(); 引入css类 */
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/registerSuccess.vue